export function isItalic(pending, unsettled) {
    return pending || unsettled;
}
